import {combineReducers} from 'redux';
import {params, paramsAreLoading, paramsHasErrored} from './params';
import {appScreen} from './app';

export default combineReducers({
    params,
    paramsHasErrored,
    paramsAreLoading,
    appScreen
});



// WEBPACK FOOTER //
// ./src/lib/redux/reducers/index.js